import { Badge, Button, Typography } from "@/components/atoms";
import { clsx } from "@/utils";

interface PricingMethodProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string; 
  description: string; 
  icon: JSX.Element;
  onConfigure: () => void;
  warning?: string;
}

export const PricingMethodCard = ({ title, description, icon, onConfigure, warning, className, children, ...props }: PricingMethodProps) => {
  return (
    <div
      className={clsx(
        "relative flex flex-col items-center rounded-lg bg-white border border-neutral-mid-gray px-5 pb-5 pt-8 max-w-[363px]",
        className
      )}
      {...props}
    >
      {warning && <Badge size="sm" type="warning" message={warning} isIconBadge className="absolute left-2.5 top-2.5" />}
      {icon}
      <Typography variant="h2" className="text-center mt-4">{title}</Typography>
      <Typography variant="paragraph" className="text-center text-neutral-dark-gray mt-1">{description}</Typography>
      <div className="flex flex-col mt-6 flex-1 w-full items-center">
        {children}
      </div>
      <Button variant="primary" size="lg" className="w-full mt-6" onClick={onConfigure}>
        {`Configure ${title}`}
      </Button>
    </div>
  );
};